const locale = {
  locationLayerPlaceholder: 'Signature Area',
  loadingError: 'PDF is not loaded successfully, please try again later',
  signatureDefaultTitle: 'Signature',
  signatureConfirmText: 'Confirm',
  signatureCancelText: 'Cancel',
  signatureCleanText: 'Clean',
  signatureEmptyError: 'Signature content cannot be empty',
  signatureSuccess: 'Signature Success',
  signatureAdd: 'Please add signature'
};

export default locale;
